import { isEmpty, isString } from "lodash";
import React from "react";

import ACResponsiveTags from "ac-components/ac-responsive-tags/ACResponsiveTags";

import { CellRenderers } from "./tableUtils";

export const ASSET_EVENTS_MAP = {
  TAGS_UPDATE: "TAGS_UPDATE",
  NAME_UPDATE: "NAME_UPDATE",
  ACTIVE_UPDATE: "ACTIVE_UPDATE",
  ENVIRONMENT_UPDATE: "ENVIRONMENT_UPDATE",
  PRODUCT_UPDATE: "PRODUCT_UPDATE",
  DNS_NAME_UPDATE: "DNS_NAME_UPDATE",
  CLOUD_PROVIDER_UPDATE: "CLOUD_PROVIDER_UPDATE",
  OS_UPDATE: "OS_UPDATE",
  OS_VERSION_UPDATE: "OS_VERSION_UPDATE",
  HOSTNAME_UPDATE: "HOSTNAME_UPDATE",
  IPV4_UPDATE: "IPV4_UPDATE",
  IPV6_UPDATE: "IPV6_UPDATE",
  CLOUD_ACCOUNT_ID_UPDATE: "CLOUD_ACCOUNT_ID_UPDATE",
  ARN_UPDATE: "ARN_UPDATE",
  MAC_ADDRESS_UPDATE: "MAC_ADDRESS_UPDATE",
  LOCATION_UPDATE: "LOCATION_UPDATE",
  OWNER_UPDATE: "OWNER_UPDATE",
  SUB_PRODUCT_UPDATE: "SUB_PRODUCT_UPDATE",
  CORRELATED_ASSET_FOUND: "CORRELATED_ASSET_FOUND",
  ASSET_DELETED: "ASSET_DELETED",
  ASSET_REAPPEARED: "ASSET_REAPPEARED",
  ASSET_CREATED_FROM_FINDINGS: "ASSET_CREATED_FROM_FINDINGS",
  IMAGE_VERSION_ADDED: "IMAGE_VERSION_ADDED",
  TOOL_TYPE_UPDATE: "TOOL_TYPE_UPDATE",
  SERIAL_NUMBER_UPDATE: "SERIAL_NUMBER_UPDATE",
  FQDN_UPDATE: "FQDN_UPDATE",
  CLOUD_RESOURCE_ID_UPDATE: "CLOUD_RESOURCE_ID_UPDATE",
};

export const formatArrayField = (data: string[] | undefined) =>
  !isEmpty(data) ? (
    <ACResponsiveTags
      tagProps={{
        mode: "plain",
        style: {
          //used color inherit as the plain mode color matches with the label color of the field
          color: "inherit",
        },
      }}
      tags={isString(data) ? [data] : data || []}
    />
  ) : (
    CellRenderers.VALUE_OR_NA()
  );
